// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"0895d293","35":"989e1cd1","72":"981cf5eb","785":"81e9799f","787":"3408ea56","861":"4f310970"}[chunkId] + ".chunk.js";
};